import type { Rule } from "antd/lib/form";
import i18n from "i18next";

import type { ValidationRuleParams } from "../../../types/types";

export const getNumberMinRule = (validationRuleParams: ValidationRuleParams) => {
    if (!validationRuleParams || validationRuleParams.length === 0) {
        return undefined;
    }

    const MIN_VALUE_ARG = 0;

    return {
        validator: (_, value) => {
            if (!value) {
                return Promise.resolve();
            }

            const number = Number(value);

            if (number >= Number(validationRuleParams[MIN_VALUE_ARG])) {
                return Promise.resolve();
            }
            return Promise.reject(i18n.t("common.input.shortOfValueNumber.error", { minNumber: validationRuleParams[MIN_VALUE_ARG] }));
        },
    } as Rule;
};
